import { d as i, i as n } from "./debounce-c95729f2.js";
var a = "Expected a function";

var r = function r(_r, t, e) {
  var o = !0,
      f = !0;
  if ("function" != typeof _r) throw new TypeError(a);
  return n(e) && (o = "leading" in e ? !!e.leading : o, f = "trailing" in e ? !!e.trailing : f), i(_r, t, {
    leading: o,
    maxWait: t,
    trailing: f
  });
};

export { r as t };